import { FormSwitchField, lt } from '@mews/framework';
import { ArticlePath, createGuideLink } from '@mews-commander/enums';
import { NewTabLink } from '@mews-commander/ui';
import { IconName, Stack, Typography } from '@optimus-web/core';
import { ConfigureDeviceAuthFieldNames } from './useConfigureDeviceAuthForm';

export function ConfigureDeviceAuthPanelContent() {
    return (
        <Stack vertical spacing="200">
            <FormSwitchField label={lt('DeviceAuthConfigurationSwitch')} name={ConfigureDeviceAuthFieldNames.Enabled} />
            <Typography textStyle="bodyMedium" as="p">
                {lt('DeviceAuthConfigurationSwitchHelp')}
            </Typography>
            <NewTabLink
                icon={IconName.ExternalLink}
                url={createGuideLink(ArticlePath.TrustedDeviceAuthorization)}
                size="small"
                standalone
                strong
                variant="basic"
            >
                {lt('DeviceAuthConfigurationGuideLink')}
            </NewTabLink>
        </Stack>
    );
}
